var map = {
	"./devices/MacbookPro.png": 802,
	"./devices/Smartphone.png": 803,
	"./devices/SmartphoneiPhone.png": 804,
	"./devices/SmartphoneiphoneCamera.png": 805,
	"./devices/browser.png": 806,
	"./devices/smartphonePixel.png": 807
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/devices\/[^\/]+\.(jpg|jepg|png)$
// module id = 801
// module chunks = 1 3